<template>
  <div
    class="navbar"
    :class="$store.state.isPc ? 'pc_navbar flexCC' : 'mobile_navbar'"
  >
    <div class="navCenter" :class="$store.state.isPc ? 'centerWidth' : ''">
      <div class="navlogo">
        <a href="/">
          <img src="@/assets/image/smingtechlogo.png" alt="" />
        </a>
        <div class="companyName">
          <span class="name">赛鸣科技</span>
          <span class="ename">SMINGTECH CO.,LTD</span>
        </div>
      </div>
      <!-- v-if="$store.state.isPc"  -->
      <transition name="slide-fade">
        <el-menu
          v-if="(mobileMenuShow && !$store.state.isPc) || $store.state.isPc"
          :default-active="$store.state.navActiveIndex"
          :active="$store.state.navActiveIndex"
          :class="
            $store.state.isPc ? 'el-menu-demo titleList flexCC' : 'mobile_menu'
          "
          :text-color="variables.fontColord"
          :active-text-color="variables.fontColorb"
          :mode="$store.state.isPc ? 'horizontal' : 'vertical'"
          @select="handleSelect"
          @open="handleOpen"
          @close="handleClose"
        >
          <!-- 菜单部分 -->

          <!-- 第2组 -->
          <el-menu-item
            v-for="item in titleListArr"
            :index="item.i"
            :key="item.index"
          >
            <!-- {{ item.name }} -->
            <el-sub-menu
              :index="item.i"
              v-if="item.menus"
              :popper-offset="22"
              popper-class="poper-class"
            >
              <template #title>
                <div style="padding-left: 10px; padding-right: 10px">
                  {{ item.name }}
                </div>
              </template>
              <!-- <div style="width: 100vw; margin-left: -30px"> -->
              <el-menu-item
                :index="item.i"
                style="width: 100vw; background-color: white; height: auto"
              >
                <div
                  class="menu-container"
                  @mouseover="handlemouseovermenu($event)"
                >
                  <!--  -->
                  <el-tabs
                    tab-position="left"
                    class="demo-tabs"
                    :model-value="activeName"
                    @mouseover="handlemouseover($event)"
                  >
                    <el-tab-pane
                      v-for="(item, index) in activeMenusArr"
                      :label="item.title"
                      :key="index"
                      :name="item.title"
                    >
                      <div class="right-container">
                        <div v-for="(child, i) in item.children" :key="i">
                          <div
                            class="menu-title"
                            @click="goDetail(child.path, $event)"
                          >
                            {{ child.title }}
                          </div>
                          <div style="display: flex; flex-wrap: wrap">
                            <div
                              v-for="(menu, index) in child.menus"
                              :key="index"
                              :class="[
                                activeIndex == 1 ? 'width-30' : 'width-50',
                              ]"
                            >
                              <div
                                style="
                                  display: flex;
                                  width: 100%;
                                  align-items: center;
                                "
                                class="menu-sub-title"
                                @click="goDetail(menu.path, $event)"
                              >
                                <span>{{ menu.title }}</span>

                                <span
                                  class="iconfont icon-arrow"
                                  style="
                                    display: inline-block;
                                    width: 20px;
                                    height: 20px;
                                    position: relative;
                                    top: -5px;
                                    margin-left: 10px;
                                  "
                                ></span>
                              </div>
                              <div class="menu-content">
                                {{ menu.content }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </el-tab-pane>
                  </el-tabs>
                </div>
                <!--  -->
              </el-menu-item>
            </el-sub-menu>
            <template v-else>
              <div style="padding-left: 10px; padding-right: 10px">
                {{ item.name }}
              </div>
            </template>
          </el-menu-item>

          <!--  -->
        </el-menu>
      </transition>
    </div>
  </div>
</template>
<script setup>
import variables from "@/assets/css/variables.module.scss";
import { useRouter, useRoute } from "vue-router";
import { onBeforeUnmount, onMounted, reactive, ref } from "vue";
import { useStore } from "vuex";
import { TabPaneName } from "element-plus";
const store = useStore();
const router = useRouter();
// 抽屉
const drawer = ref(false);
const direction = ref("ttb");
const isShow = ref(false);
// 鼠标移入激活的索引
const activeName = ref("热门产品");

// 激活的菜单中的索引
const activeMenusIndex = ref(0);
const menusSolution = ref([
  {
    id: "001",
    title: "热门方案",
    children: [
      {
        id: "001",
        title: "安全生产",
        menus: [
          {
            title: "企业安全生产数智化管控解决方案",
            content:
              "促进企业安全管理数智化转型升级，推动操作控制智能化、风险预警精准化、危险作业无人化、运维辅助远程化。平台融合风险辨识与隐患排查的核心思想，以安全管理要素为基石，集成数据采集、智能诊断、模型分析、监控预警于一体，具有双重预防、特殊作业、教育培训、智能巡检、人员定位、智能视频监控等功能。",
            path: "",
          },
          {
            title: "政府安全生产综合智能解决方案",
            content:
              "省、市、区县应急管理部门对重点行业领域企业的危险源、风险、隐患进行监测和管理，遏制重大安全生产事故的发生。包括领导驾驶舱、一企一档、物联监测、视频监测、智能预警、风险分级管控、隐患排查理、特殊作业管理、敏捷应急、数据治理等业务系统，为各级政府管控辖区公共安全提供支持。",
            path: "",
          },
        ],
      },
      {
        id: "002",
        title: "企业运营",
        menus: [
          {
            title: "企业数字化运营管理解决方案",
            content:
              "基于数字化低代码开发平台构造全新的数字化协同管理方式，应用于企业销售订单、资源检查、计划排程、采购、生产、质检、仓储、设备、成品追溯等各个场景，涵盖了完整的企业数字化运营管理需求。基于数据聚合、可视化分析、实时监控、智能决策等功能版块帮助企业实现作业无纸化，提升数字化运营管理能力。",
            path: "",
          },
        ],
      },
      {
        id: "003",
        title: "电商新零售",
        menus: [
          {
            title: "新零售现场管理数字化解决方案",
            content:
              "促进企业线上和线下业务的融合，连接人、货、场，构建企业新零售现场管理闭环。其中包括线上小程序商城、线上促销管理、 现场活动管理、会员营销管理、现场收银管理、现场发货管理等基础功能，同时增加了数据分析与可视化、智能推荐系统、无人自助购物、社交电商功能、智能客服等高级特性。",
            path: "",
          },
          {
            title: "数字化会议会展活动解决方案",
            content:
              "基于数字化和智能化技术的会议会展活动管理平台通过微信平台接入、活动场景互动营销、营销运营服务、个性化推荐与定制、数据分析与报告等功能特点，实现企业会议会展活动的数字化管理，应用于会前宣传、会前邀约、到会确认、数字签到、会中互动、会中营销、会后跟进、客户培育等场景。",
            path: "",
          },
        ],
      },

      {
        id: "004",
        title: "市政房产",
        menus: [
          {
            title: "数字化不动产资产管理解决方案",
            content:
              "立足不动产全生命周期管理精细化，从登记、纳管、维护、处置、释放五个关键节点逐层细化。搭建完整不动产管理体系，明确各环节管控要求，依法依规对企业不动产进行规范化管理，优化包括租入、盘点、巡检、转资、调拨、置换等关键场景流程环节，使企业管理不动产权证账实真实清晰，完整支撑不动产管理。",
            path: "/solution",
          },
          {
            title: "智慧项目巡查管理解决方案",
            content:
              "基于移动技术和物联网技术建立一套信息化、智能化的项目巡查管理平台，它通过移动设备、传感器、视频监控等技术，智慧项目巡查管理平台: 实现对于项目的实时监控和数据采集，并通过数字化手段呈现出来，方便管理人员进行巡查和管理。包括项目管理、项目审批、巡查任务、巡查记录、异常上报施工监护、项目监测等功能。",
          },
        ],
      },
      {
        id: "006",
        title: "人力资源",
        menus: [
          {
            title: "线上教育培训平台解决方案",
            content:
              "基于互联网和数字化技术的在线教育培训平台，旨在提供各类培训课程和学习资源，提高学员的学习效率和培训质量。平台包含在线课程管理、多样化学习资源、在线直播课堂、学习评价与反馈、个性化推荐与定制、移动学习体验、数据分析与报告等功能。提供多种学习方式和支持服务，满足不同学员的需求和学习偏好。",
            path: "",
          },
        ],
      },
    ],
  },
]);
const menusProduct = ref([
  {
    id: "001",
    title: "热门产品",
    children: [
      {
        id: "001",
        title: "安全生产",
        menus: [
          {
            title: "智慧型安全生产一体化管控平台",
            content:
              "高效融合监测预警、高风险作业管理、隐患排查治理、应急指挥调度等功能，实现企业安全生产全过程、全要素一体化、数字化、智能化、可视化管理。",
            path: "",
          },
          {
            title: "双重预防数字化平台",
            content:
              "风险辨识评估、隐患排查治理、统计分析等多功能于一体的平台。利用数字化技术，提高企业安全管理的效率和准确性。",
            path: "",
          },
          {
            title: "特殊作业票管理平台",
            content:
              "完成八大特殊作业票全过程在线办理,将各个部门的移动办票、审批流程、作业资格证、安全措施、数据上报、证据留存、现场作业和监控、作业票管理等业务进行整合。",
            path: "",
          },
        ],
      },
      {
        id: "002",
        title: "企业运营",
        menus: [
          {
            title: "数字化低代码开发平台",
            content:
              "采用可视化业务建模、流程拖拽、表单搭建、规则配置、智能报表、大屏设置等技术，通过零代码快速构建业务应用。",
            path: "",
          },
          {
            title: "企业数字化运营管理平台",
            content:
              "基于低代码开发平台构造全新的数字化协同管理方式，平台涵盖了销售、采购、排程、生产、质检、仓储、设备、OA等完整的企业数字化运营管理需求。",
            path: "",
          },
        ],
      },
      {
        id: "003",
        title: "电商新零售",
        menus: [
          {
            title: "线上线下一体化智慧零售平台",
            content:
              "将线上商城与线下实体店进行深度融合，通过数字化手段实现会员、线上店、实体店三位一体的社交新零售生态闭环。",
            path: "",
          },
          {
            title: "会员营销平台",
            content:
              "整合多渠道会员数据，实现自动化营销，实时分析数据并优化策略，降低人工成本，提高营销效率。",
            path: "",
          },
        ],
      },

      {
        id: "004",
        title: "市政房产",
        menus: [
          {
            title: "智慧不动产管理平台",
            content:
              "通过数字化手段实现不动产的资产管理、租赁管理、巡检管理、报修管理、销售管理、财务管理等功能，从而实现资产闭环管理。",
            path: "",
          },
        ],
      },
      {
        id: "006",
        title: "人力资源",
        menus: [
          {
            title: "企业线上培训平台",
            content:
              "拥有丰富多样的学习资源，智能化的培训功能，满足移动学习，个性化学习需求。提高培训效率和质量，降低成本，增强企业竞争力。",
            path: "",
          },
        ],
      },
    ],
  },
  //安全生产
  {
    id: "02",
    title: "安全生产",
    children: [
      {
        id: "001",
        title: "",
        menus: [
          {
            title: "安全生产双重预防控制系统",
            content:
              "风险辨识评估、隐患排查治理、统计分析等多功能于一体的平台。利用数字化技术，提高企业安全管理的效率和准确性。",
            path: "",
          },
          {
            title: "特殊作业票管理系统",
            content:
              "完成八大特殊作业票全过程在线办理,将各个部门的移动办票、审批流程、作业资格证、安全措施、数据上报、证据留存、现场作业和监控、作业票管理等业务进行整合。",
            path: "",
          },
          {
            title: "安全生产应急指挥系统",
            content:
              "集信息采集、监测、预警、通讯、指挥和调度于一体的综合平台，快速响应和处理各类安全生产事故。通过实时数据采集、分析，实现快速预警和调度，确保应急工作的高效有序进行，保障人员安全和企业生产安全。",
            path: "",
          },
          {
            title: "安全教育培训系统",
            content:
              "基于互联网和多媒体技术的在线培训平台，旨在提供全方位、个性化的安全知识学习和培训服务。通过丰富的课程内容、灵活的学习方式，提高员工的安全意识和技能水平，为企业安全生产保驾护航。",
            path: "",
          },
          {
            title: "企业安全检查系统",
            content:
              "集成智能化、信息化技术的安全风险评估与监控体系。通过实时监测、数据分析和预警，确保企业生产过程中的安全风险得到及时发现和有效控制。为企业提供科学、规范的安全管理解决方案，提升企业的安全管理水平。",
            path: "",
          },
          {
            title: "企业消防安全管控系统",
            content:
              "集成智能化、信息化技术的安全风险评估与监控体系。通过实时监测、数据分析和预警，确保企业生产过程中的安全风险得到及时发现和有效控制。同时，该系统还能为企业提供科学、规范的安全管理解决方案，提升企业的安全管理水平。",
            path: "",
          },
          {
            title: "重大危险源监控管理系统",
            content:
              "针对高风险区域和设备进行实时监控与预警的综合性系统，通过数据采集、分析和处理，及时发现潜在的安全隐患，确保危险源处于可控状态，有效预防事故的发生，保障生产安全。",
            path: "",
          },
          {
            title: "访客管理系统",
            content:
              "是一款智能化、高效化的管理软件，旨在实现访客信息的快速登记、验证与跟踪，提升企业或园区的安全水平。该系统可简化访客流程，提高通行效率，同时确保访客活动的可追溯性，保障企业安全。",
            path: "",
          },
        ],
      },
    ],
  },
  //3
  {
    id: "03",
    title: "企业运营",
    children: [
      {
        id: "001",
        title: "",
        menus: [
          {
            title: "CRM客户关系管理系统",
            content:
              "帮助企业提高客户满意度和忠诚度，优化销售、市场和服务流程。整合客户信息、跟进销售机会、管理营销活动，提升企业业绩和客户体验。",
            path: "",
          },
          {
            title: "OMS订单管理系统",
            content:
              "帮助企业实现订单的快速录入、跟踪、分配和出库，同时优化库存管理，减少人工错误，提高订单处理效率和客户满意度，是企业电商和物流管理的得力助手。",
            path: "",
          },
          {
            title: "CMS合同管理系统",
            content:
              "专注于企业合同管理的高效工具，提供合同起草、审批、签署、执行和归档等全流程管理。该系统可确保合同数据的准确性、安全性和可追溯性，有效降低合同风险，提高企业合规水平。",
            path: "",
          },
          {
            title: "SRM采购管理系统",
            content:
              "为企业打造的高效采购工具，旨在优化采购流程、降低采购成本。支持供应商管理、采购需求分析、订单跟踪等功能，助力企业实现采购的智能化和透明化，提升整体运营效率。",
            path: "",
          },
          {
            title: "MOM制造运营管控系统",
            content:
              "集生产计划、物料管理、生产执行、质量控制于一体的智能化管理工具。可实时监控制造过程，优化资源配置，提高生产效率与产品质量，助力制造企业实现精益化管理与转型升级。",
            path: "",
          },
          {
            title: "MES生产管理系统",
            content:
              "实现生产过程的数字化、可视化和智能化。通过实时数据采集、生产计划排程等功能，优化生产流程，提高生产效率，确保产品质量，是制造企业不可或缺的生产管理工具。",
            path: "",
          },
          {
            title: "QMS质量管理系统",
            content:
              "整合质量标准、检验流程和控制手段，确保从原材料到成品的每一环节都严格符合质量要求，有效预防并减少质量风险，增强企业竞争力。",
            path: "",
          },
          {
            title: "Andom安灯异常管理系统",
            content:
              "通过即时反馈生产现场异常，实现快速响应和处理。该系统有助于提升生产效率、降低质量风险，并促进持续改进，是现代制造企业不可或缺的生产异常管理解决方案。",
            path: "",
          },
          {
            title: "WMS仓储管理系统",
            content:
              "通过自动化、精细化的仓库作业流程管理，实现库存的精准控制和快速响应。大幅提升仓储效率、降低运营成本，是现代企业不可或缺的仓储管理利器。",
            path: "",
          },
          {
            title: "EMS设备管理系统",
            content:
              "集设备监控、维护、调度于一体，通过智能化数据分析，为企业提供全面的设备管理解决方案。有效预防设备故障，优化资源配置，降低运维成本，提高企业生产效率和设备使用寿命。",
            path: "",
          },
          {
            title: "称重管理系统",
            content:
              "实现对称重过程的自动化、精准化管理。能实时记录、监控和分析称重数据，有效防范作弊行为，确保数据真实可靠。",
            path: "",
          },
        ],
      },
    ],
  },
  //   电商
  {
    id: "04",
    title: "电商新零售",
    children: [
      {
        id: "001",
        title: "",
        menus: [
          {
            title: "统一会员身份管理",
            content:
              "集会员信息整合、身份验证、权限分配于一体的综合性管理工具。打通多个应用与平台间的身份壁垒，实现单点登录与统一授权，提升会员管理的便捷性与系统安全性。",
            pathName: "solution",
          },
          {
            title: "多租户商城系统",
            content:
              "为多个商家提供独立电商店铺解决方案的平台，每个租户拥有独立的品牌、商品、订单和客户管理功能。系统支持自定义装修、灵活扩展，且具备良好的数据隔离和安全性，助力企业快速搭建并运营自己的电商平台。",
            pathName: "solution",
          },
          {
            title: "OM订单管理平台",
            content:
              "专为电商行业打造的订单管理工具，支持多平台、多店铺订单统一管理，实现订单快速处理、智能分配及高效跟踪。提升订单处理效率，降低出错率，助力电商企业提升客户满意度和运营效益。",
            pathName: "solution",
          },
          {
            title: "支付管理平台",
            content:
              "多种支付方式于一体的综合性管理工具，为商户提供安全、便捷、高效的支付服务。支持多种支付渠道，具备强大的风险控制和数据分析功能，确保交易安全稳定，助力商户提升支付体验和经营效率。",
            pathName: "solution",
          },
          {
            title: "收银管理系统",
            content:
              "高效、智能的店铺收款工具，支持多种支付方式，实现快速结账和精准对账。该系统可简化收银流程，提高工作效率，同时保障交易安全，为商家提供便捷、可靠的收银管理解决方案。",
            pathName: "solution",
          },
          {
            title: "统一消息发送平台",
            content:
              "集成了多种消息通道的综合性发送工具，通过统一的接口和管理界面，实现快速、精准的消息群发和个性化定制。该平台可广泛应用于企业营销、通知提醒等场景，提升消息发送的效率和准确性。",
            pathName: "solution",
          },
          {
            title: "现场拣发货管理系统",
            content:
              "高效、智能的仓储管理工具，通过优化拣货路径、实时更新库存信息，实现快速、准确的拣货和发货。可显著提升仓储作业效率，降低出错率，为企业创造更大的物流价值。",
            path: "",
          },
          {
            title: "预约管理系统",
            content:
              "便捷、高效的在线预约工具，支持用户自助预约、管理预约信息，并提供实时更新和提醒功能，提升预约效率和用户满意度。",
            path: "",
          },
          {
            title: "排队叫号系统",
            content:
              "实现顾客有序排队、自动叫号的智能管理工具。通过取号、叫号、显示等功能，有效维护现场秩序，提升服务效率。为用户提供便捷、公平的排队体验。",
            path: "",
          },
          {
            title: "会议会展活动管理系统",
            content:
              "专为各类会议、展览活动打造的综合管理工具，涵盖活动策划、报名签到、日程管理、资源分配等功能，实现活动流程的智能化、规范化管理，提高活动组织效率和参会体验。",
            path: "",
          },
        ],
      },
    ],
  },
  {
    id: "05",
    title: "市政房产",
    children: [
      {
        id: "001",
        title: "",
        menus: [
          {
            title: "智慧不动产管理平台",
            content:
              "利用先进的大数据分析和人工智能技术，实现不动产资产的全周期管理，包括资产盘点、运营分析、风险预警等功能，助力企业高效决策，保障资产安全增值。",
            path: "",
          },
          {
            title: "房产销售管理系统",
            content:
              "专为房地产行业设计的综合性软件，涵盖客户管理、房源管理、销售跟踪等功能。该系统可帮助房产企业高效管理销售流程，提升团队协作效率，实现销售业绩的快速增长。",
            path: "",
          },
          {
            title: "房产租赁管理系统",
            content:
              "集房源管理、租约跟踪、租金收缴于一体的综合性软件，专为租赁业务打造。帮助房产企业轻松管理租赁流程，确保租约执行无误，实现租金收益最大化。",
            path: "",
          },
          {
            title: "房屋维护保养管理系统",
            content:
              "集报修、派工、维修、验收、结算等功能于一体的智能化管理软件，通过实时跟踪维修进度、确保维修质量，提供高效便捷的房屋维修服务。提升物业维修管理水平，增强用户满意度。",
            path: "",
          },
          {
            title: "物业管理系统",
            content:
              "集房屋管理、业主服务、费用收缴、设备维护等功能于一体的综合性管理软件，旨在提供高效、便捷的物业服务，优化资源配置，提升管理水平和业主满意度。",
            path: "",
          },
        ],
      },
    ],
  },
  {
    id: "06",
    title: "人力资源",
    children: [
      {
        id: "001",
        title: "",
        menus: [
          {
            title: "线上教育培训平台",
            content:
              "基于网络的综合性学习工具，提供海量优质课程和培训资源。通过实时互动、智能推荐等功能，满足不同学员个性化需求，实现随时随地高效学习，助力个人成长和职业发展。",
            path: "",
          },
          {
            title: "考勤打卡系统",
            content:
              "便捷高效的员工考勤管理工具，通过手机定位、人脸识别等技术手段，确保员工准时到岗，实时记录考勤数据。帮助企业规范考勤流程，减少人为操作失误，提高管理效率。",
            path: "",
          },
          {
            title: "共享用工系统",
            content:
              "基于互联网的灵活用工平台，旨在实现人力资源的高效配置。通过智能匹配企业与劳动者的需求，提供临时性、项目性的工作机会，助力企业灵活调整用工结构，满足市场快速变化的需求。",
            path: "",
          },
          {
            title: "调查问卷系统",
            content:
              "在线数据收集与分析工具，通过创建、发布问卷并收集用户反馈，帮助企业、研究机构快速获取市场信息、用户意见等数据，为决策提供有力支持，实现精准的市场调研和用户需求分析。",
            path: "",
          },
        ],
      },
    ],
  },
]);
const activeMenusArr = ref([]);

// 第2组菜单
const titleListArr = reactive([
  { i: "0", name: "首页", pathName: "home" },
  { i: "1", name: "产品", menus: menusProduct },

  {
    i: "2",
    name: "解决方案",
    menus: menusSolution,
  },
  //   { i: "2", name: "解决方案", pathName: "solution" },
  { i: "3", name: "关于赛鸣", pathName: "aboutSm" },
  { i: "4", name: "加入我们", pathName: "joinus" },
]);
const mobileMenuShow = ref(false);
const handleSelect = (key, keyPath) => {
  //   if (key == "1" || key == "2") {
  //     return false;
  //   }
  router.push({ name: titleListArr[key].pathName });
  store.commit("navFunc", key);
  if (!store.state.isPc) mobileMenuShow.value = false;
};
//菜单打开
const activeIndex = ref(1);
const handleOpen = (index) => {
  //   console.log(index);
  activeIndex.value = index;
  activeMenusArr.value = titleListArr[index].menus;
  activeName.value = titleListArr[index].menus[0].title;

  //   设置滚动条禁用
  //   document.addEventListener(
  //     "mousewheel",
  //     function (e) {
  //       e.preventDefault();
  //     }
  //     // { passive: false }
  //   );
};
// const handleClose = () => {
//   //   设置滚动条禁用
//   document.addEventListener(
//     "mousewheel",
//     function (e) {
//       e.preventDefault();
//     }
//     // { passive: true }
//   );
// };
// 菜单切换

const handlemouseover = (e) => {
  var title = e.target.id.slice("4");
  if (title) {
    //   console.log(title);
    activeName.value = title;
  }
};
// 阻止事件冒泡
const goDetail = (path, event) => {
  if (path) {
    router.push(path);
  } else {
    event.stopPropagation();
  }
};
// 阻止事件冒泡
const handlemouseovermenu = (event) => {
  //   event.stopPropagation();
  //   event.preventDefault();
};
const showmoreFunc = () => {
  mobileMenuShow.value = !mobileMenuShow;
};
onMounted(() => {
  // 模拟外部点击
  document.addEventListener("click", (e) => {
    if (
      e.target.className !== "mobile_menu" &&
      e.target.className !== "showMore"
    ) {
      mobileMenuShow.value = false;
    }
  });
});
onBeforeUnmount(() => {
  window.removeEventListener("click", () => {}, true);
});

//
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "@/assets/css/public.scss";
@import "@/assets/font/iconfont.css";

::v-deep .el-sub-menu__title {
  height: 36px !important;
  font-size: 18px !important;
  text-align: center;
  //   background-color: yellow;
  //   border: 1px solid blue;
  display: flex;
  width: auto !important;
  padding: 0px;
}
::v-deep .el-popper.is-pure {
  margin-left: -23px !important;
  width: 110vw !important;
}
::v-deep .el-menu--horizontal .el-menu-item:not(.is-disabled):hover {
  background-color: white !important;
}
::v-deep .el-sub-menu .el-sub-menu__icon-arrow {
  display: none;
}
::v-deep .el-sub-menu__title:hover {
  background-color: white !important;
  color: #1788ee !important;
}
//
::v-deep .el-tabs__nav-scroll {
  height: calc(60vh - 30px);
}
//
::v-deep .el-tabs__nav {
  width: 150px;
  //   border: 1px solid green;
}
::v-deep .el-tabs__item {
  height: 50px;
  font-size: 20px;
  font-weight: 600 !important;
  text-align: center !important;
  //   border: 1px solid blue;
  //   background-color: yellow;
  color: #404d57;
  padding-right: 30px !important;
}
::v-deep .el-tabs__item.is-active {
  color: #1788ee;
}
// ::v-deep .el-tabs__item:hover {
//   color: #1788ee !important;
// }
::v-deep .el-tabs__nav-prev {
  display: none;
}
::v-deep .el-tabs__nav-next {
  display: none;
}
::v-deep .el-tabs__item i {
  display: none;
}
.pc_navbar.navbar {
  .navCenter {
    height: 90px;
    position: relative;
    display: flex;
    justify-content: flex-start;
    align-items: center;

    .navlogo {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      a {
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .companyName {
        display: flex;
        flex-direction: column;
        margin-left: 10px;
        font-family: Source Han Sans CN;
        text-align: left;
        font-weight: bold;
        // width: 130px;

        .name {
          font-size: 20px;
          line-height: 30px;
          letter-spacing: 0.1em;
        }

        .ename {
          font-size: 12px;
          line-height: 18px;
          letter-spacing: 0em;
        }
      }
    }

    .titleList {
      //   height: 100%;
      margin: 0 0 0 150px;
    }
  }

  ::v-deep .el-menu--horizontal {
    border: 0;

    .el-menu-item {
      font-size: 18px;
      //   font-weight: 600;
      padding: 0;
      //   padding-left: 18px;
      margin: 0 9px;
      //   border: 1px solid red;
      //   width: 80px;
      margin-left: 35px;
      height: 37px;
      text-align: center;
    }

    .is-active {
      text-align: center;
      background: none !important;
      border-bottom: 3px solid $fontColorb;
    }

    .el-menu-item:hover {
      color: $fontColorb;
      background: none;
    }

    .el-menu-item:before {
      content: "";
      position: absolute;
      z-index: 9999;
      width: 100%;
      height: 2px;
      // bottom: -5px;
      bottom: -2px;
      left: 0;
      background-color: $fontColorb;
      visibility: hidden;
      -webkit-transform: scaleX(0);
      -o-transform: scaleX(0);
      transform: scaleX(0);
      -webkit-transition: all 0.3s ease-in-out 0s;
      -o-transition: all 0.3s ease-in-out 0s;
      transition: all 0.3s ease-in-out 0s;
    }

    .el-menu-item:hover:before {
      visibility: visible;
      -webkit-transform: scaleX(1);
      -o-transform: scaleX(1);
      transform: scaleX(1);
      z-index: 9999;
    }
  }
  .el-tabs .el-tabs__content::v-deep {
    padding: 132px;
    color: #6b778c;
    font-size: 32px;
    font-weight: 600;
  }
  .el-tabs .el-tabs--left .el-tabs__item.is-left {
    // border: 1px solid red;
    width: 180px !important;
  }
  .el-tabs--right .el-tabs__content,
  .el-tabs--left .el-tabs__content {
    height: 100%;
  }

  ::v-deep .el-menu ul {
    width: 100vw;
    // background-color: red;
    margin-left: -23px;
  }
}
.menu-container {
  box-shadow: 0 7px 6px rgba(0, 0, 0, 0.15) !important;
  width: 100%;
  height: 60vh;
  background-color: white;
  padding-top: 60px;
  padding-bottom: 20px;
  position: absolute;
  left: -22px;
  top: -10px;
}
.right-container {
  height: calc(60vh - 30px);
  overflow-y: auto;
  padding-right: 30px;
}
/* 修改垂直滚动条 */
.right-container::-webkit-scrollbar {
  width: 3px; /* 修改宽度 */
  background-color: rgba(0, 0, 0, 0.1);
}
.right-container::-webkit-scrollbar:horizontal {
  height: 10px; /* 设置滚动条宽度 */
}
.right-container::-webkit-scrollbar-thumb {
  background-color: #a8abb2; /* 设置滑块背景色为#888 */
  height: 50px;
}
.demo-tabs {
  width: 1200px;
  //   border: 1px solid red;
  margin: 0 auto;
}
.el-tabs__item.is-left::v-deep {
  width: 200px;
  //   border: 1px solid red;
}
.demo-tabs .el-tabs--left .el-tabs__nav.is-left::v-deep {
  width: 200px;
  //   border: 1px solid red;
}
.menu-title {
  font-size: 20px;
  font-weight: 600;
  //   margin-bottom: 20px;
  line-height: 50px;
  margin-left: 60px;

  color: #404d57 !important;
}
.menu-title:hover {
  // #1788ee
  color: #1788ee !important;
  //   color: #004baa !important;
}
.menu-sub-title {
  //   color: #606266;
  font-size: 18px;
  color: #404d57 !important;
  margin-bottom: 3px;
}
.menu-sub-title:hover {
  color: #1788ee !important;
}
.menu-sub-title:hover span {
  color: #1788ee !important;
}
.menu-content {
  width: 100%;
  font-size: 16px;
  white-space: normal;
  word-wrap: break-word;
  line-height: 25px;
  //   margin-top: 10px;
  margin-bottom: 45px;
  color: #404d57 !important;
  display: -webkit-box; /* 必须设置此项才能生效 */
  -webkit-line-clamp: 2; /* 限制最大行数 */
  -webkit-box-orient: vertical; /* 垂直布局 */
  overflow: hidden; /* 超出部分隐藏 */
  text-overflow: ellipsis; /* 显示省略号 */
}
.width-50 {
  width: 50%;
  padding-left: 60px;
  //   padding-right: 60px;
  box-sizing: border-box;
  //   border: 1px solid red;
}
.width-30 {
  width: 33%;
  //   border: 1px solid red;
  padding-left: 60px;
  box-sizing: border-box;
}
.menu-sub-title:hover ::v-deep .el-icon {
  color: #1788ee !important;
}
.mobile_navbar {
  // background: pink;
  width: 100vw;
  height: 67px;
  font-size: 18px;
  display: flex;
  align-items: center;

  // height: 90px;
  // font-size: 22px;
  .navCenter {
    width: 100vw;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;

    .navlogo {
      display: flex;
      margin-left: 15px;
      z-index: 99999;

      a {
        display: flex;
        justify-content: center;
      }

      img {
        margin-right: 10px;
      }

      .companyName {
        display: flex;
        flex-direction: column;
        justify-content: center;

        .name {
          font-weight: bold;
        }

        .ename {
          font-size: 10px;
        }
      }
    }

    .mobile_menu {
      // display: none;
      position: absolute;
      top: 57px;
      z-index: 9999;
      width: 100vw;
      // transition: display 1s linear 0;
    }

    // .fade-enter-active,
    // .fade-leave-active {
    //   // transition: opacity .5s linear;
    //   transition: opacity 0.5s ease;
    // }

    // .fade-enter {
    //   opacity: 0;
    // }
    .slide-fade-enter-active {
      transition: all 0.3s ease-out;
    }

    .slide-fade-leave-active {
      transition: all 0.5s cubic-bezier(1, 0.5, 0.8, 1);
    }

    .slide-fade-enter-from,
    .slide-fade-leave-to {
      transform: translateY(-30px);
      opacity: 0;
    }

    .showMore {
      height: 30px;
      width: 30px;
      background: url("@/assets/image//icon/more_ico.png") no-repeat center/30px
        30px;
      margin-right: 20px;
    }
  }
}
::v-deep .el-menu--popup {
  padding: 0px;
  border-radius: 0px;
}
</style>
